import langLogin from '@views/login/lang/zh'
import langAuthority from '@views/authority/lang/zh'
import langAdmin from '@views/admin/lang/zh'
import userHome from '@views/home/lang/zh'
import parentLogin from '@views/parentLogin/lang/zh'
import user from '@views/user/lang/zh'

export default {
  message: {
    'hello': '你好，世界'
  },
  home: {
    moduleClose: '模块暂未开通',
    tips1: '扫描二维码，关注学校微信公众号，及时查看动态变化'
  },
  button: {
    printing: '打印',
    sendMssage: '发送消息',
    sendMssageText1: '入学通知',
    sendMssageText2: '重新提交通知',
    retBtn: '重置',
    serBtn: '查询',
    seniorSerBtn: '高级搜索',
    questionnaire: '推送调查问卷',
    import: '导入',
    export: '导出',
    more: '更多',
    or: '或',
    addBtn: '添加',
    copy: '复制',
    upload: '上传',
    updBtn: '修改',
    dltBtn: '删除',
    returnBtn: '返回',
    ediBtn: '编 辑',
    cncBtn: '取 消',
    surBtn: '确 定',
    submitBtn: '确 定',
    laststep: '上一步',
    next: '下一步',
    Savenextstep: '保存&下一步',
    complete: '完 成',
    savBtn: '保 存',
    submission: '提交',
    enableFlag: '是否有效',
    operation: '操作',
    addadvisoryBtn: '添加新咨询内容',
    close: '关闭',
    Lateradd: '稍后添加',
    Immediatelyadd: '立即添加',
    Submitimmediately: '立即提交',
    approved: '审核通过',
    giveUp: '放弃',
    checkAll: '全选',
    returnSchool: '立即返回学校总览',
    returnIndex: '立即返回首页',
    dialogMessageCnc: '重新选择',
    dialogMessageSurBtn: '确认发送',
    addBtnTip: '添加',
    dltBtnTip: '删除',
    logInNow: '立即登录',
    yyaccount: '已有账号',
    backPage: '返回登录页'
  },
  search: {},
  fromMsg: {
    printing: '打印',
    handoverSuccess: '切换成功！',
    noteNull: '输入的笔记内容不能为空！',
    phoneNull: '输入的手机号码不能为空！',
    passwordNull: '输入的密码不能为空！',
    newPasswordNull: '输入的确认密码不能为空！',
    passwordMistaken: '输入的密码或确认密码有误！',
    getPassword: '请获取正确的短信验证码！',
    originalPwdX: '请输入原密码',
    newPwdPwdX: '请输入新密码',
    newPwdPwdF: '请输入确认密码',
    phone: '请输入有效的手机号！',
    phoneOrEmail: '请输入有效的手机号或邮箱！',
    email: '请输入有效的邮箱！',
    getCode: '获取验证码',
    getCode2: '点击获取',
    getCodeRepeat: '重新发送',
    codeYZ: '请获取正确的短信验证码！',
    inquiryContent: '请输入咨询内容',
    gradeId: '请选择学生在读年级',
    parentName: '请输入联系人姓名',
    recommendSource: '请选择推荐来源',
    code: '请选择验证码',
    uploadImg: '仅限上传jpg,png格式的图片',
    citizenship: '请输入国籍',
    firstName: '请输入名',
    lastName: '请输入姓',
    fullName: '请输入全名',
    gender: '请选择性别',
    smsCode: '请输入验证码',
    passwordX: '请输入密码',
    passwordF: '请输入确认密码',
    atypism: '两次密码不一致',
    actionUser: '请输入姓名',
    schoolName: '申请学校',
    gradeName: '申请年级',
    tourDate: '参观日期',
    startTime: '参观时间',
    maxRemain: '剩余名额',
    maxCount: '单次参观人数上限',
    remark: '说明',
    mailHost: '发件服务器地址',
    mailSmtpPort: '请输入服务器端口',
    mailUsername: '请输入用户名',
    mailPassword: '请输入密码',
    smsAccessKeyId: '短信通道秘钥id',
    smsAccessKeySecret: '短信通道秘钥',
    appId: '请输入应用id',
    appSecret: '请输入秘钥',
    key: '请输入支付密钥',
    mchId: '请输入商户id',
    encodingAesKey: '请输入微信公众号推送消息',
    token: '请输入微信公众号推送消息token',
    appIdOpen: '开放平台APPID',
    appSecretOpen: '开放平台密钥',
    qrCodePath: '请上传公众号二维码',
    certPath: '请上传微信支付证书',
    certPathZq: '请上传正确的支付证书',
    mailTemplate: '请先编辑邮件内容！',
    mailTemplatetit: '邮件发送内容模板',
    mailSubject: '邮件发送主题',
    parentPhone: '请输入联系人电话',
    picPath: '请上传照片',
    nationality: '请选择国籍',
    firstNameLength: '长度在 1 到 20 个字符',
    lastNameLength: '长度在 1 到 20 个字符',
    fullNameLength: '长度在 1 到 40 个字符',
    firstNameSpell: '请输入名-拼音',
    firstNameSpellLength: '长度在 1 到 20 个字符',
    lastNameSpell: '请输入姓-拼音',
    lastNameSpelllLength: '长度在 1 到 20 个字符',
    birthday: '请选择出生日期',
    sex: '请选择性别',
    credentialsType: '请选择证件类型',
    credentialsNumber: '请输入证件号',
    credentialsNumberLength: '长度在 1 到 20 个字符',
    surveyNameZh: '请输入中文问卷名称',
    surveyNameEn: '请输入英文问卷名称',
    surveyremark: '请输入问卷说明',
    closingDate: '请选择截止日期',
    questionType: '请选择题型',
    questionNameZh: '请输入中文描述',
    questionNameEn: '请输入英文描述',
    studentName: '请选择学生',
    examgradeId: '请选择年级',
    examDateId: '请选择考试日期',
    examLocation: '请填写考场',
    examRemark: '请填写考试科目时间说明',
    linkmanName: '请填写联系人姓名',
    examPaySuccess: '缴费成功！',
    tourDateId: '请选择参观日期',
    tourTime: '请选择参观时间',
    tourCount: '请填写参观人数',
    tourMaxTotal: '请填写最大参观人数',
    tourMaxCount: '请填写单个参观最大申请人数',
    tourAddRemark: '请填写参观信息补充',
    surveyId: '请输入问卷',
    theVisit: '确认取消参观吗?',
    linkmanPhone: '请填写联系人手机',
    linkmanEmail: '请填写联系人邮箱',
    SelectedVisiting: '参观人数大于所选参观日期的单次参观人数上限',
    studentsNo: '未选择学生',
    Unfilled: '未填写完整',
    UnfilledNuber: '未填写申请参观人数',
    education: '请输入学历',
    linkmanNameJ: '请输入紧急联系人姓名',
    relationshipJ: '请输入紧急联系人关系',
    linkmanPhoneJ: '请输入紧急联系人手机号',
    linkmanEmailJ: '请输入紧急联系人邮箱',
    emailZ: '请填写准考证接收邮箱',
    Nofiletype: '未选择文件类型',
    NotourDateId: '未选择参观日期',
    NoexamgradeId: '未选择年级',
    Noselection: '未选择报考年级',
    Noexamination: '未选择考试日期',
    examEditTypes1: '考试状态更改',
    examEditTypes2: '录取状态更改',
    mailY: '邮寄',
    ExtractionY: '自取',
    paymentType: '请选择缴费类型',
    acceptType: '请选择接收方式',
    postName: '请填写收件人姓名',
    postCode: '请填写邮编',
    postAddress: '请填写地址',
    acceptDate: '请选择取件日期',
    acceptTime: '请选择取件时间',
    confirmexam: '确认取消考试吗',
    Tips: '提示',
    codename: '请输入类型名称',
    codevalue: '请输入类型编号',
    sortOptions1: '上级类型名称',
    sortOptions2: '类型名称',
    sortOptions3: '类型编码',
    effective: '有效',
    Invalid: '失效',
    Uploadingfile: '上传文件',
    nationalityId: '国籍ID',
    surveyquestions: '有部分调查问题未选择选项',
    tourCountZq: '请填写正确参观人数',
    responsibleperson: '请选择责任人',
    beforesave: '选项未完善',
    NoRecord: '过往学校记录未完善',
    AddedSuccessfully: '新增成功',
    labelName: '标签名不能为空！',
    newLabelName: '新增标签名不能为空！',
    Studentinformation: '请先建立学生信息档案！',
    noTour: '没有对应年级参观安排，请致电招生办！',
    noExam: '没有对应年级考试安排，请致电招生办！',
    TimeDownBefore: '您已完成咨询',
    TimeDownAfter: '秒后将自动返回学校总览',
    submitSuccess: '提交成功！',
    consultSubmitSuccess: '您的咨询已提交，学校招生老师会尽快联系您！',
    tourTip: '该学生有未完成的参观申请!',
    examTip: '该学生有未完成的考试申请!',
    appTip: '该学生已有入学申请!',
    addTip: '最多添加三个联系人信息',
    validInt: '请输入有效的数字'
  },
  confirm: {
    type: '提示',
    deleterecord: '确认删除该记录吗?',
    message: '确认删除该消息吗?',
    theVisit: '确认取消参观吗?',
    cancelExam: '确认取消面试吗?',
    updateDate: '确认更改日期吗?',
    abandon: '确认放弃录取吗?',
    questionnaireExpired: '该问卷已过期',
    changeTip: '确认进行此操作吗?'
  },
  langLogin: langLogin,
  langAuthority: langAuthority,
  langAdmin: langAdmin,
  userHome: userHome,
  parentLogin: parentLogin,
  user: user,
  cropper: {
    uploadPictures: '上传图片',
    uploadAgain: '重新上传',
    resetImage: '重置图像',
    cancel: '取消',
    determine: '确定',
    tips1: '图片格式错误，支持图片格式JPG、JPEG、PNG',
    tips2: '文件大小不能超过5M'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js